import {inject, Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {IConnectedClientInfo} from "../interfaces/IConnectedClientInfo";
import * as signalR from '@microsoft/signalr';
import {AppConfigService} from "./app-config.service";

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private appConfigService: AppConfigService = inject(AppConfigService);
  private potTotalHubConnection: signalR.HubConnection | null = null;
  private connectedClientsBehSub: BehaviorSubject<IConnectedClientInfo[]> = new BehaviorSubject<IConnectedClientInfo[]>([]);
  public connectedClients$: Observable<IConnectedClientInfo[]> = this.connectedClientsBehSub.asObservable();

  public listenToConnectedClientChanges() {
    if (this.potTotalHubConnection) {
      return; // Prevent multiple connections
    }

    const commonApi = this.appConfigService.commonApiUrl();

    this.potTotalHubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${commonApi}/gameGroupHub`, {withCredentials: true})
      .withAutomaticReconnect()
      .build();

    this.potTotalHubConnection.start()
      .then(() => {
        console.log('✅ Connected to SignalR hub');
        this.potTotalHubConnection!.on('UpdateClientList', (clients: IConnectedClientInfo[]) => {
          console.log('📡 SignalR update received:', clients);
          this.connectedClientsBehSub.next(clients);
        });
      })
      .catch((error) => {
        console.error('❌ SignalR connection failed:', error);
      });
  }
}
